import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=9f132a68&scoped=true&"
import script from "./addService.vue?vue&type=script&lang=ts&"
export * from "./addService.vue?vue&type=script&lang=ts&"
import style0 from "./addService.vue?vue&type=style&index=0&id=9f132a68&lang=scss&scoped=true&"
import style1 from "./addService.vue?vue&type=style&index=1&id=9f132a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f132a68",
  null
  
)

export default component.exports